import React, { FC } from 'react'
import {
	WrapperColor,
	Wrapper,
	Title,
	ElementsWrapper,
	FirstTitle,
	SecondTitle,
	ThirdTitle,
} from './styled'
import { ServicePackagesElementComponent } from './ServicePackagesElement'

export const ServicePackagesComponent: FC = () => (
	<WrapperColor>
		<Wrapper>
			<Title>Тарифы для бизнеса</Title>
			<ElementsWrapper>
				<ServicePackagesElementComponent
					title={() => <FirstTitle>СберБизнес Прайм</FirstTitle>}
					subtitle="для ИП и ООО"
					firstElementTitle="От 0 ₽ в месяц"
					firstElementSubtitle="Стоимость подписки СберБизнес Прайм"
					secondElementTitle={'300 000 ₽ без комиссии для ООО\n500 000 ₽ без комиссии для ИП'}
					secondElementSubtitle="Платежи физлицам"
					thirdElementTitle="От 5 бесплатных платежей в любые банки, включая Сбер"
					thirdElementSubtitle="Платежи юрлицам"
				/>
				<ServicePackagesElementComponent
					title={() => <SecondTitle>Только для селлеров</SecondTitle>}
					subtitle="Работа на маркетплейсах"
					firstElementTitle="2 190 ₽ в месяц"
					firstElementSubtitle="0 ₽ в первый месяц обслуживания"
					secondElementTitle="Без комиссии выручка с маркетплейсов"
					secondElementSubtitle="Платежи физлицам"
					thirdElementTitle="10 бесплатных платежей через СберБизнес, включая Сбер"
					thirdElementSubtitle="Платежи юрлицам"
				/>
				<ServicePackagesElementComponent
					title={() => <ThirdTitle>Новые рынки</ThirdTitle>}
					subtitle="Зарубежные контрагенты"
					firstElementTitle="3 990 ₽ в месяц"
					firstElementSubtitle="В течение всего срока обслуживания"
					secondElementTitle="500 000 ₽ без комиссии"
					secondElementSubtitle="Платежи физлицам"
					thirdElementTitle="20 бесплатных платежей"
					thirdElementSubtitle="Платежи юрлицам, рублевый и валютный счет"
				/>
			</ElementsWrapper>
		</Wrapper>
	</WrapperColor>
)
